// extracted by mini-css-extract-plugin
module.exports = {"container":"_M17FOKHE"};